import React from "react";
import { Route, Navigate, Routes } from "react-router-dom";
import CryptoJS from 'crypto-js';
import Overview from "../../Pages/Overview/Overview"
import Complaints from "../../Pages/Complaints/Complaints"
import IncentiveManagement from "../../Pages/Incentive Mangement/Incentive"
import Services from "../../Pages/Services/Service"
import CustomerPaymentHistory from "../../Pages/Customer Payment History/CustomerPyamentHistory"
import Transactions from "../../Pages/Transactions/Transactions"
import Simpl from "../../Pages/SIMPL/Simpl"
import Refund from "../../Pages/Transactions/Refund"
import Unauthorized from "../../Pages/Unauthorized/Unauthorized";
import User from "../../Pages/Users/User";
import CustomerParameters from "../../Pages/Customer Parameters/CustomerParameters";
import ClientCredential from "../../Pages/Client Credential/clientCredential";
import Communicationchannel from "../../Pages/Communication Channel/communication";
import Mails from "../../Pages/Mails";
import Recon from "../../Pages/ReconAndSettlement/Recon";
import HelpandSupport from "../../Pages/HelpSupport/HelpSupport";
import AgentDetails from "../../Pages/AgentDetails/AgentDetials";
import Agents from "../../Pages/Agent/Agent";
import Logger from "../../Pages/Logger/Logger";
import Biller from "../../Pages/BillerDetail/Biller";
import DashboardLogger from "../../Pages/DashboardLogger/Index"


function AppRouters() {
    const permissionsLocalStorage = localStorage.getItem('module_access');
    const decryptedData = permissionsLocalStorage 
        ? CryptoJS.AES.decrypt(permissionsLocalStorage, process.env.REACT_APP_ENCRYPTED_KEY).toString(CryptoJS.enc.Utf8) 
        : null;
  
    const permissionsData = decryptedData ? JSON.parse( decryptedData ) : {};
    const permissions = permissionsData.permissions || [];

    return (
        <div className="AppPageConntent">
        <Routes>
            <Route path="/" element={<Overview />} />
            <Route path="/transactions" element={checkPermission(permissions, "transactions") ? <Transactions /> : <Navigate to="/unauthorized" />} />
            <Route path="/agents" element={checkPermission(permissions,"Agents") ? <Agents /> : <Navigate to="/unauthorized"/>} />
            {/* <Route path="/client-Credential" element={checkPermission(permissions, "transactions") ? <ClientCredential /> : <Navigate to="/unauthorized" />} /> */}
            {/* <Route path="/refund" element={checkPermission(permissions, "refund") ? <Refund /> : <Navigate to="/unauthorized" />} /> */}
            <Route path="/complaints" element={checkPermission(permissions, "complaints") ? <Complaints /> : <Navigate to="/unauthorized" />} />
            <Route path="/customer-payment-history" element={checkPermission(permissions, "Customer Payment History") ? <CustomerPaymentHistory /> : <Navigate to="/unauthorized" />} />
            {/* <Route path="/simpl" element={checkPermission(permissions, "simpl") ? <Simpl /> : <Navigate to="/unauthorized" />} /> */}
            <Route path="/users" element={checkPermission(permissions, "users") ? <User /> : <Navigate to="/unauthorized" />} />
            {/* <Route path="/customer-parameters" element={checkPermission(permissions, "customer-parameters") ? <CustomerParameters /> : <Navigate to="/unauthorized" />} /> */}
            <Route path="/communication-channel" element={checkPermission(permissions, "customer-parameters") ? <Communicationchannel /> : <Navigate to="/unauthorized" />} />
            <Route path="/mails" element={checkPermission(permissions, "mails") ? <Mails /> : <Navigate to="/unauthorized" />} />
            <Route path="/recon-and-settlement" element={checkPermission(permissions, "Recon And Settlement") ? <Recon /> : <Navigate to="/unauthorized" />} />
            <Route path="/logger" element={checkPermission(permissions, "logger") ? <Logger /> : <Navigate to="/unauthorized" />} />

            <Route path="/agent-details" element={checkPermission(permissions, "Agent Details") ? <AgentDetails/> : <Navigate to="/unauthorized" />} />
            <Route path="/biller-detail" element={checkPermission(permissions, "Biller Detail") ? <Biller/> : <Navigate to="/unauthorized" />} />
            <Route path="/activity-logs" element={checkPermission(permissions, "activity-logs") ? <DashboardLogger/> : <Navigate to="/unauthorized" />} />
            <Route path="/help-support" element={checkPermission(permissions, "Help & Support") ? <HelpandSupport /> : <HelpandSupport />} />



            {/* <Route path="/incentive-management" element={checkPermission(isSuperAdmin, permissions, "incentive_management") ? <IncentiveManagement/> : <Navigate to="/unauthorized" />} /> */}
            {/* <Route path="/services" element={checkPermission(isSuperAdmin, permissions, "service_list") ? <Services /> : <Navigate to="/unauthorized" />} /> */}
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="*" element={<Unauthorized/>} />
        </Routes>
        </div>
    );
}

function checkPermission(permissions, requiredPermission) {
    return Array.isArray(permissions) && permissions.some(permission => permission.module.toLowerCase() === requiredPermission.toLowerCase() && permission.read);
}

export default AppRouters;
